import { isEqual } from 'lodash';

export const isEqualObject = (firstObject: any, secondObject: any) => isEqual(firstObject, secondObject);
